 <!--Full width header Start-->
<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>
<!--Full width header End-->
<!-- Main content Start -->
<div class="main-content">
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">FAQs</h1>
      <ul>
        <li><a class="active" href="/">Home</a></li>
        <li>
          <a>About</a>
        </li>
        <li>FAQs</li>
      </ul>
    </div>
  </div>

  <div class="rs-inner-blog orange-color pt-100 pb-100 md-pt-70 md-pb-70 representative-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-12 pr-50 md-pr-15">
          <about-menu></about-menu>
        </div>
        <div class="col-lg-8 rs-faq-part style1 orange-color">
          <div class=" main-part">
            <div class="title mb-40 md-mb-15">
              <h2 class="text-part">Frequently Asked Questions</h2>
            </div>
            <div class="faq-content">
              <div id="accordion" class="accordion">
                <div class="card">
                  <div class="card-header">
                    <a class="card-link" data-toggle="collapse" href="#collapseOne">
                      When was the educational society established?
                    </a>
                  </div>
                  <div id="collapseOne" class="collapse show" data-parent="#accordion">
                    <div class="card-body">
                      The Educational society was established in the year 1991.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header">

                    <a class="card-link collapsed" data-toggle="collapse" href="#collapseTwo" aria-expanded="false">
                      Who were founding members of the educational society?
                    </a>
                  </div>
                  <div id="collapseTwo" class="collapse" data-parent="#accordion" style="">
                    <div class="card-body">
                      Dr. Palle Raghunatha Reddy and Smt. Palle Uma.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header">

                    <a class="card-link collapsed" data-toggle="collapse" href="#collapseThree" aria-expanded="false">
                      What Kind of courses do we offer for 12A eligible under our educational society?
                    </a>
                  </div>
                  <div id="collapseThree" class="collapse" data-parent="#accordion" style="">
                    <div class="card-body">
                      We offer a wide variety of disciplines through 40 + independent institutes.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header">

                    <a class="card-link collapsed" data-toggle="collapse" href="#collapsefour" aria-expanded="false">
                      Whare are all of colleges located?
                    </a>
                  </div>
                  <div id="collapsefour" class="collapse" data-parent="#accordion" style="">
                    <div class="card-body">
                      With over 15+ campuses, we are located all over Anantapur District. Please check "our College locations" tab in the menu above to view colleges by location.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header">
                    <a class="card-link collapsed" data-toggle="collapse" href="#collapsefive" aria-expanded="false">
                      How do I contact top level management?
                    </a>
                  </div>
                  <div id="collapsefive" class="collapse" data-parent="#accordion" style="">
                    <div class="card-body">
                      You can email the chairman at <a href="mailto:chairman@sbesatp.org">Chairman@sbesatp.org</a> <p>
                        For generic questions, please reach us through <a routerLink="/contact">Contact Us</a> page.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->
